/** Session timeout in milliseconds (30 minutes of inactivity) */
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000

/**
 * localStorage key for the step each Plan of Care draft was left on
 * (poc-draft-progress.ts). It belongs to the draft, not the session, so it is
 * kept when logout / a 401 clears the rest of localStorage — otherwise a draft
 * saved today would reopen on its first step after the session timed out.
 */
export const POC_DRAFT_PROGRESS_KEY = 'pocDraftProgress'
